import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge class names with clsx, then resolve Tailwind conflicts with
 * tailwind-merge (last-wins). The standard design-system class combiner.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
